import { notification } from 'antd';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useMutation } from 'react-query';

import IconWrap from '../IconWrap';

import { DeleteBinIcon, PlusIcon } from '@/assets/icons';
import { LocalFileResponseDTO } from '@/dto/responseDto/local-file.dto';
import localFileService from '@/services/local-file.service';
import { handleMessageError } from '@/util/handleMessageError';
import './style.scss';

interface IProps {
    onFileChanges?: any;
    photo?: any;
}
const imageMimeType = /image\/(png|jpg|jpeg)/i;

const UploadImage: React.FC<IProps> = ({ onFileChanges, photo }) => {
    const inputRef = useRef<any>(null);
    const handleClick = () => {
        inputRef.current.click();
    };

    const [baseImage, setBaseImage] = useState<LocalFileResponseDTO | null>();

    const uploadImage = async (e: any) => {
        const file = e.target.files[0];
        if (!file.type.match(imageMimeType)) {
            notification.error({
                message: 'LỖI UPLOAD',
            });
            return;
        }
        mutateUploadFile(file);
    };

    const { mutate: mutateUploadFile } = useMutation(
        ['upload-file'],
        (file: File) => localFileService.uploadFile(file),
        {
            onSuccess: (data: any) => {
                setBaseImage(data.data);
            },
            onError: (error: any) => {
                handleMessageError(error);
            },
        },
    );
    useEffect(() => {
        onFileChanges(baseImage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseImage]);

    useEffect(() => {
        if (photo && photo.path) {
            setBaseImage(photo);
        } else {
            setBaseImage(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [photo]);

    return (
        <div className="upload-card">
            <div
                className={classnames('button-upload', {
                    uploaded: baseImage && baseImage?.path && !baseImage.isDelete,
                })}
                onClick={handleClick}
            >
                <IconWrap size={24} icon={<PlusIcon />} />
                <input
                    style={{ display: 'none' }}
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    value=""
                    multiple={false}
                    onChange={(e) => {
                        uploadImage(e);
                    }}
                />
            </div>
            {baseImage && baseImage.path && !baseImage.isDelete && (
                <div className="image-uploaded">
                    <img src={process.env.REACT_APP_STORAGE + baseImage?.path} alt="" />
                    <IconWrap
                        onClick={() => setBaseImage((prev: any) => ({ ...prev, isDelete: true }))}
                        className="remove-icon"
                        size={18}
                        icon={<DeleteBinIcon />}
                    />
                </div>
            )}
        </div>
    );
};

export default React.memo(UploadImage);
